import { render } from "./tickets.vue?vue&type=template&id=c7a71704&scoped=true"
import script from "./tickets.vue?vue&type=script&lang=js"
export * from "./tickets.vue?vue&type=script&lang=js"

import "./tickets.vue?vue&type=style&index=0&id=c7a71704&scoped=true&lang=css"
import "./tickets.vue?vue&type=style&index=1&id=c7a71704&lang=css"

import exportComponent from "C:\\inetpub\\wwwroot\\frontend\\employer-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7a71704"]])

export default __exports__